/** @format */

import DateOnly from '../../../../utilities/format/date';
import ProofApproval from '../../proofs/proof_approval';
import Moment from 'moment/moment';
import {PROOF_TYPE_ELECTRONIC, PROOF_TYPE_PRINTED} from 'frontier-constants';
import {Table} from '@sttark/design-system';
import {If} from 'frontier-utilities';
import React from 'react';

export const OrderProofs = props => {
    const {onUpdateProof, proofs} = props;

    const columns = [
        {
            title: 'Proof',
            index: 'proof',
            key: 'proof'
        },
        {
            title: 'Tracking Number',
            index: 'Shipment_key',
            key: 'Shipment_key'
        },
        {
            title: 'Created Date',
            index: 'created_date',
            key: 'created_date'
        }
    ];

    const rows = proofs.map((proof, index) => {
        return {
            proof: (
                <div>
                    <If condition={proof.type_id == PROOF_TYPE_ELECTRONIC}>
                        <p className="p-0 m-0">Electronic</p>
                    </If>
                    <If condition={proof.type_id == PROOF_TYPE_PRINTED}>
                        <a
                            href={`/account/proofs/download-proof?key=${proof.s3key}&bucket=${process.env.FILESTACK_PROOF_CONTAINER}`}
                            target="_blank">
                            {proof.filename}
                        </a>
                    </If>
                </div>
            ),
            Shipment_key: (
                <div>
                    <If condition={proof.type_id == PROOF_TYPE_ELECTRONIC}>
                        <span title={proof.email + ' ' + proof.cc}>
                            <>
                                {proof.email}
                                <br />
                                {proof.cc}
                            </>
                        </span>
                    </If>
                    <If condition={proof.type_id == PROOF_TYPE_PRINTED}>
                        <span>
                            {proof.external_status_label}{' '}
                            {proof.addresses_proofs.map(({address, ...addressesProof}) => {
                                return (
                                    <div key={addressesProof.id}>
                                        <div>
                                            <a
                                                target="_blank"
                                                href={`/account/shipments/tracking-number/${addressesProof.tracking_code}`}>
                                                {addressesProof.tracking_code}
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                        </span>
                    </If>
                </div>
            ),
            created_date: <DateOnly>{proof.created}</DateOnly>,
            key: proof.id
        };
    });

    return <Table rows={rows} columns={columns} />;
};
